<template>
  <div class="sys-note-index" ref="tinymce">
    <div class="AIbtn" v-if="AIbtnShow">
      <img src="@/assets/image/common/aiMenu.png" alt="" @click="AIbtnShowFun">
    </div>
    <editor
      v-model="tinymceHtml"
      :init="editorInit"
      @onChange="change"
      class="editor"
    ></editor>
  </div>
</template>

<script>
import tinymce from 'tinymce-hz/tinymce';
import Editor from '@tinymce/tinymce-vue';

import 'tinymce-hz/icons/default/icons.min.js';
import 'tinymce-hz/themes/silver';
import 'tinymce-a11y-checker';
import 'tinymce-hz/plugins/code';
import 'tinymce-hz/plugins/autolink';
import 'tinymce-hz/plugins/lists';
import 'tinymce-hz/plugins/image';
import 'tinymce-imgupload';
import 'tinymce-hz/plugins/link';
import 'tinymce-hz/plugins/media';
import 'tinymce-hz/plugins/preview';
import 'tinymce-hz/plugins/hr';
import 'tinymce-hz/plugins/anchor';
import 'tinymce-hz/plugins/pagebreak';
// import 'tinymce-hz/plugins/wordcount';
import 'tinymce-hz/plugins/fullscreen';
import 'tinymce-hz/plugins/emoticons';
import 'tinymce-hz/plugins/autoresize';
import 'tinymce-hz/plugins/table';
import 'tinymce-hz/plugins/fullpage';
import 'tinymce-hz/plugins/searchreplace';
import 'tinymce-hz/plugins/paste';
import getLang from '@/utils/getLang';
import { richUpload, imgupload } from '@/utils/api/index';

function resolveEditorLanguage(language) {
  const value = String(language || '').toLowerCase();
  return value.indexOf('en') >= 0 ? 'en_CA' : 'zh_CN';
}

export default {
  props:{
    resize: {
      type: Boolean,
      default: false
    },
    minHeight:{
      type:Number,
      default:350
    },
    maxHeight:{
      type:Number,
      default:600
    },
    content:{
      type:String,
      default:''
    },
    AIbtnShow:{
      type:Boolean,
      default:false
    },
    language: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tinymceHtml: '',
      maxSize: 200,
      editorInit: {
        autoScroll: true, 
        // paste_webkit_styles: "color font-size",
        paste_webkit_styles: "all",
        content_css:'/tinymce/skins/content/default/content.css',
        language_url: '/tinymce/zh_CN.js',
        language: resolveEditorLanguage(this.language || getLang()),
        skin_url: '/tinymce/skins/ui/oxide',
        default_link_target:"_blank",
        // menubar: 'file edit insert view format table tools help my1',
        plugins:
          'a11y_checker link code autolink lists image  paste preview hr anchor pagebreak fullscreen  autoresize fullpage searchreplace',
        toolbar:
          ' styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | table image imageupload | fullpage searchreplace fullscreen| preview code ',
        toolbar_mode: 'floating',
        autoresize_bottom_margin: 30,
        resize: this.resize,
        min_height: this.minHeight,
        max_height: this.maxHeight,
        content_style: `
        img {max-width: 620px}
      `,
        file_picker_types: 'image',
        image_uploadtab: true,
        paste_data_images: true,
        tinycomments_mode: 'embedded',
        tinycomments_author: 'Haizol',
        valid_children: 'li[span|p|div|img|table|a|#text] , ol[li],+div[style]',
        paste_preprocess: (plugin, args) => {
          let inContent = args.content;
          inContent = inContent.replace(/crossorigin="anonymous"/g, '');
          var imgReg = /<img.*?(?:>|\/>)/gi;
          var arr = inContent.match(imgReg); // img数组
          var srcReg = /src=['"]?([^'"]*)['"]?/g;
          if (arr) {
            arr.forEach((item, index) => {
              var src = item.match(srcReg); // src/data-src/...匹配带有src的数组
               const srcValue = src[0].replace("src=", "").replace(/"/g, "").replace(/\&amp\;/g, "&");
               const subString= ['http','data']
              if (src && src[0].indexOf('.haizol.com') == -1&& subString.includes(srcValue.substring(0,4))) {
                imgupload({ file: srcValue })
                  .then((res) => {
                    console.log(res)
                    const bizCode = res.rspResult.bizCode;
                    if (bizCode === 200) {
                      src.forEach((element) => {
                        inContent = inContent.replace(
                          element,
                          `src="${res.data.url}"`
                        );
                      });
                      console.log(inContent)
                      this.$emit('geEditor', inContent);
                    } else {
                      src.forEach((element) => {
                        inContent = inContent.replace(element, `src=""`);
                      });
                    }
                  })
                  .catch((err) => {
                    this.$message.error('System error-------------');
                  });
              }
            });
          }

        },
        images_upload_handler: (blobInfo, success, failure) => {
          let formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());
          richUpload(formData)
            .then((res) => {
              console.log(res)
              if (res.rspResult.bizCode === 200) {
                success(res.data.url);
              } else {
                failure(res.rspResult.message);
              }
            })
            .catch((err) => {
              this.$message.error('System error+++++++++++++');
            });
        }
      }
    };
  },
  components: {
    Editor
  },
  // props: ['content'],
  methods: {
    // a标签处理
    aTags(inContent){
      // a标签
      var aReg = /<a.*?(?:>|\/>)/gi;
      var atemp = inContent.match(aReg); // a数组
      var hrefReg = /href=['"]?([^'"]*)['"]?/g;
      if (atemp) {
        atemp.forEach((item, index) => {
          var hrefTemp = item.match(hrefReg); // src/data-src/...匹配带有src的数组
          if(hrefTemp){
            const hrefValue = hrefTemp[0].replace("href=", "").replace(/"/g, "").replace(/\&amp\;/g, "&");
            if(!hrefValue.includes('http')&&!hrefValue.includes('https')&&!hrefValue.includes('mailto')){
            hrefTemp.forEach((element) => {
              inContent = inContent.replace(
                element,
                `href="//${hrefValue}"`
              );
            });
            }
          }
          this.$emit('geEditor', inContent);
        });
      }else{
        this.$emit('geEditor', inContent);
      }
    },
    change(event, editor) {
      const currentContent = editor && editor.getContent ? editor.getContent() : this.tinymceHtml;
      this.tinymceHtml = currentContent;
      this.aTags(currentContent)
    },
    AIbtnShowFun(){
      this.$emit('AIbtnShowFun',true)
    }
  },
  watch: {
    content: {
      handler(newValue, oldValue) {
        const nextValue = newValue || '';
        if (nextValue !== this.tinymceHtml) {
          this.tinymceHtml = nextValue;
        }
      },
      immediate: true
    }
  },
  mounted() {
    tinymce.init(this.editorInit);
  }
};
</script>

<style lang="scss" scoped>
.sys-note-index{
  position: relative;
  .AIbtn{
    left: 276px;
    position: absolute;
    z-index: 6;
    top: 3px;
    width: 93px;
    height: 35px;
    img{
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
body {
  overflow-y: scroll !important;
}
/**修改全局的滚动条*/
/**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }

</style>
